import { render, staticRenderFns } from "./CultureCreate.vue?vue&type=template&id=2e45c615&scoped=true&"
import script from "./CultureCreate.vue?vue&type=script&lang=js&"
export * from "./CultureCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e45c615",
  null
  
)

export default component.exports